module.exports = __webpack_public_path__ + "static/18-1ddcd1c3629adcb197689f297596d88c.wav";